import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
} from "react";
import FullCalendar from "@fullcalendar/react"; // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid"; // a plugin!
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import "./eventCalendar.css";
import { SidebarContext } from "contexts/SidebarContext";
import useServerTime from "hooks/useServerTime";

function EventCalendar(props) {
  const {
    calendarData,
    initialDate,
    getValueMonthChange,
    selectShow,
    yearUpdate,
    monthUpdate,
    searchKey,
  } = props;
  const { sidebarWidth } = useContext(SidebarContext);
  const calendarRef = useRef(null);
  const todayVN = useServerTime();
  useEffect(() => {
    setTimeout(() => {
      window.dispatchEvent(new Event("resize"));
    }, 150);
  }, [sidebarWidth]);

  // Navigate calendar to selected year/month when search is triggered
  useEffect(() => {
    if (calendarRef.current && yearUpdate !== undefined && monthUpdate !== undefined && searchKey > 0) {
      const calendarApi = calendarRef.current.getApi();
      const targetDate = new Date(yearUpdate, monthUpdate, 1);
      calendarApi.gotoDate(targetDate);
    }
  }, [searchKey]);

  const renderDayCell = ({ date }) => {
    const weekday = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return (
      <div className="fc-daygrid-day-top fc-day">
        <span className="fc-daygrid-day-top fc-day-label text-uppercase">{weekday[date.getDay()]}</span>{" "}
        {date.getDate()}
      </div>
    );
  };
  const renderEventContent = ({ event }) => {
    return (
      <div
        className="fc-event-content"
        style={{
          backgroundColor: `${
            event.extendedProps.status === 1
              ? event.extendedProps.show.color
              : event.extendedProps.status === 2
              ? "var(--chakra-colors-black-900)"
              : "#fb3838"
          }`,
          cursor: `${
            event.extendedProps.status === 3 ? "not-allowed" : "pointer"
          }`,
        }}
      >
        <div className="fc-event-title">
          {event.extendedProps.show.name} - {event.extendedProps.venue.name} - (
          {event.extendedProps.available} / {event.extendedProps.total}) -{" "}
          {event.extendedProps.show_time}
        </div>
      </div>
    );
  };
  const lastCalledKey = useRef(null);

  useEffect(() => {
    lastCalledKey.current = null;
  }, [searchKey]);

  const datesSet = useCallback(
    (arg) => {
      const newMonth = arg.view.currentStart.getMonth();
      const newYear = new Date(arg.view.currentStart).getFullYear();
      const key = `${newMonth}-${newYear}`;
      if (lastCalledKey.current === key) return;
      lastCalledKey.current = key;
      getValueMonthChange(newMonth, newYear);
    },
    [getValueMonthChange]
  );
  return (
    <FullCalendar
      ref={calendarRef}
      plugins={[dayGridPlugin, interactionPlugin]}
      initialView="dayGridMonth"
      initialDate={initialDate}
      events={calendarData}
      editable={false}
      height="auto"
      eventClick={(info) =>
        selectShow(info.event.id, info.event.extendedProps.status)
      }
      validRange={todayVN ? { start: todayVN } : undefined}
      lazyFetching={true}
      dayCellContent={renderDayCell}
      eventContent={renderEventContent}
      firstDay={1}
      datesSet={(arg) => {
        datesSet(arg);
      }}
      dayCellClassNames="testx"
      dayHeaderClassNames="texty"
      handleWindowResize={true}
      expandRows={true}
    />
  );
}

export default EventCalendar;
